import React from "react";
import "./PartsList.css";
import { PartModel } from "../../Models/PartModel";
import Part from "../Parts/PartSection";
import { useAuth } from "../../Context/useAuth";
import PartSection from "../../Components/Parts/PartSection";
import { Container } from "react-bootstrap";

interface Props {
  parts: PartModel[];
}

const PartsList: React.FC<Props> = ({
  parts,
}: Props): JSX.Element => {
  return (
    <div>
      {parts.length > 0 ? (
        parts.map((result) => {
          return (
            <PartSection
            partModel = {result!}
            />
          );
        })
      ) : (
        <p className="mb-3 mt-3 text-xl font-semibold text-center md:text-xl">
          No parts found
        </p>
      )}
    </div>
  );
}

export default PartsList;